'use strict';

var constants = require('../constants.cjs');
var apiError = require('./apiError.cjs');
var axiosError = require('./axiosError.cjs');
var customError = require('./customError.cjs');

function isNegligibleSentryCapture(error) {
  if (axiosError.isAxiosError(error)) {
    const [errorType, httpError] = apiError.decideError(error);
    if (error.code === "ECONNABORTED") {
      return true;
    }
    if (constants.NEGLIGIBLE_SENTRY_CAPTURE_ERROR_TYPES.includes(errorType)) {
      return true;
    }
    const code = httpError?.code;
    if (typeof code === "string" && constants.NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES.includes(code)) {
      return true;
    }
    return false;
  }
  if (customError.isRouteChangeCanceledError(error)) {
    return true;
  }
  return false;
}

exports.isNegligibleSentryCapture = isNegligibleSentryCapture;
//# sourceMappingURL=sentry.cjs.map
